// extracted by mini-css-extract-plugin
module.exports = {"stock_search":"stock_search-3S2EO-wI clearfix","text":"text-2-Ut2SB0","btn":"btn-1c6qU1io"};